export const chapterActionTypes = {
  FETCH_CHAPTERS_REQUEST: 'FETCH_CHAPTERS_REQUEST',
  FETCH_CHAPTERS_SUCCESS: 'FETCH_CHAPTERS_SUCCESS',
  FETCH_CHAPTERS_FAILURE: 'FETCH_CHAPTERS_FAILURE',

  FETCH_CHAPTER_REQUEST: 'FETCH_CHAPTER_REQUEST',
  FETCH_CHAPTER_SUCCESS: 'FETCH_CHAPTER_SUCCESS',
  FETCH_CHAPTER_FAILURE: 'FETCH_CHAPTER_FAILURE',

  ADD_CHAPTER_REQUEST: 'ADD_CHAPTER_REQUEST',
  ADD_CHAPTER_SUCCESS: 'ADD_CHAPTER_SUCCESS',
  ADD_CHAPTER_FAILURE: 'ADD_CHAPTER_FAILURE',

  EDIT_CHAPTER_REQUEST: 'EDIT_CHAPTER_REQUEST',
  EDIT_CHAPTER_SUCCESS: 'EDIT_CHAPTER_SUCCESS',
  EDIT_CHAPTER_FAILURE: 'EDIT_CHAPTER_FAILURE',

  DELETE_CHAPTER_REQUEST: 'DELETE_CHAPTER_REQUEST',
  DELETE_CHAPTER_SUCCESS: 'DELETE_CHAPTER_SUCCESS',
  DELETE_CHAPTER_FAILURE: 'DELETE_CHAPTER_FAILURE',

  TOGGLE_DARK_MODE: 'TOGGLE_DARK_MODE',
  TOGGLE_SCROLL_HORIZONTAL: 'TOGGLE_SCROLL_HORIZONTAL',
  TOGGLE_FULL_WIDTH: 'TOGGLE_FULL_WIDTH',
}

export const chapterActions = {
  fetchChapters: (payload, callback) =>
  ({
    type: chapterActionTypes.FETCH_CHAPTERS_REQUEST,
    payload,
    callback
  }),
  fetchChapter: (payload, callback) =>
  ({
    type: chapterActionTypes.FETCH_CHAPTER_REQUEST,
    payload,
    callback
  }),
  addChapter: (payload, callback) =>
  ({
    type: chapterActionTypes.ADD_CHAPTER_REQUEST,
    payload,
    callback
  }),
  editChapter: (payload, callback) =>
  ({
    type: chapterActionTypes.EDIT_CHAPTER_REQUEST,
    payload,
    callback
  }),
  deleteChapter: (payload, callback) =>
  ({
    type: chapterActionTypes.DELETE_CHAPTER_REQUEST,
    payload,
    callback
  }),
  toggleDarkMode: (payload, callback) =>
  ({
    type: chapterActionTypes.TOGGLE_DARK_MODE,
    payload,
    callback
  }),
  toggleScrollHorizontal: (payload, callback) =>
  ({
    type: chapterActionTypes.TOGGLE_SCROLL_HORIZONTAL,
    payload,
    callback
  }),
  toggleFullWidth: (payload, callback) =>
  ({
    type: chapterActionTypes.TOGGLE_FULL_WIDTH,
    payload,
    callback
  }),
};

export default chapterActions;